import { ReactNode } from 'react'
import { AuthProvider } from '@/contexts/auth-context'
import { FeatureFlagsProvider } from '@/contexts/feature-flags-context'
import { ThemeProvider } from './theme-provider'
import { Toaster } from 'sonner'

interface RootLayoutProps {
  children: ReactNode
}

export function RootLayout({ children }: RootLayoutProps) {
  return (
    <AuthProvider>
      <FeatureFlagsProvider>
        <ThemeProvider>
          <div className="font-sans antialiased">
            {children}
            <Toaster />
          </div>
        </ThemeProvider>
      </FeatureFlagsProvider>
    </AuthProvider>
  )
}
